const STRATEGIC_PARTNER = Object.freeze({
    LABEL: 'Ansel',
    SHORT_LABEL: 'Ansel',
    PALETTE: {
        PRIMARY: '#214E41',
        SECONDARY: '#43806C',
    },
    CONTACT_SUPPORT: {
        EMAIL: 'support@joinansel.com',
        NUMBER: '(888) 300-5382'
    },
    S3: {
        BASE_URL: 'https://brella-platform-assets.s3.amazonaws.com',
        SP_NAME: 'ansel',
        APPLICATION: 'member',
    },
    LEGAL:{
        TERMS: 'https://www.joinansel.com/terms',
        PRIVACY: 'https://www.joinansel.com/privacy-policy',
        SERVICE_NAME: 'Renaissance Life & Health Insurance Company of America',
    }
});

export default STRATEGIC_PARTNER;
